// extracted by mini-css-extract-plugin
export default {"label":"VolumeLabel_label__7oYbZ"};